import { getRequest, postRequest } from '../request/request.service';
import {
  IncomingNumbersResponse,
  IncomingNumbersParams,
  AvailableNumbersResponse,
  SearchAvailableParams,
  ProvisionNumberPayload,
  ProvisionNumberResponse,
  CrmPhoneNumbersResponse,
} from './phone-numbers-service.types';

const PHONE_NUMBERS_URL = 'twilio_phone_numbers';

export function getIncomingNumbers(params: IncomingNumbersParams) {
  return getRequest<IncomingNumbersResponse>(`/${PHONE_NUMBERS_URL}/incoming_numbers`, { params });
}

export function searchAvailableNumbers(params: SearchAvailableParams) {
  return getRequest<AvailableNumbersResponse>(`/${PHONE_NUMBERS_URL}/search_available`, {
    params,
  });
}

export function provisionNumber(data: ProvisionNumberPayload) {
  return postRequest<ProvisionNumberResponse>(`/${PHONE_NUMBERS_URL}/provision`, { data });
}

export function getPhoneNumbers(params: { company_id: number }) {
  return getRequest<CrmPhoneNumbersResponse>(`/${PHONE_NUMBERS_URL}`, { params });
}